import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import { LayoutCP } from 'submodules/nerit-framework-ui/common/components/screen/layout/layout/LayoutCP'
import { HeaderCP } from 'submodules/nerit-framework-ui/common/components/screen/layout/header/HeaderCP'
import { TableUtils } from 'submodules/nerit-framework-ui/common/components/table/utils/TableUtils'
import { useFormStateManager } from 'submodules/nerit-framework-ui/common/form-state-manager/UseFormStateManager'
import { CollectionControlFiltersFormModel } from 'modules/collection-performance/components/collection-control/filters-collection-control/inner/CollectionControlFiltersFormModel'
import { FiltersCollectionControlCP } from 'modules/collection-performance/components/collection-control/filters-collection-control/FiltersCollectionControlCP'
import { TableCollectionControlCP } from 'modules/collection-performance/components/collection-control/table-collection-control/TableCollectionControlCP'
import { SCREEN_FILTER_URL_PARAM } from 'submodules/nerit-framework-ui/common/screens/inner/ScreenTypes'
import { SystemUtils } from 'submodules/nerit-framework-utils/utils/SystemUtils'

/**
 * Tela 3.2 - Controle de Pontos. Grade ponto x mes com status de coleta editavel por celula.
 */
export function ScreenCollectionControl(): JSX.Element {

    const routeLocation = useLocation()

    const [formModel, setFormModel] = useState<CollectionControlFiltersFormModel>(new CollectionControlFiltersFormModel())
    const formStateManager = useFormStateManager(formModel)

    // 0 = ainda sem pesquisa; a grade so busca apos o filtro (clique ou URL)
    const [reloadData, setReloadData] = useState<number>(0)
    const [isLoading, setIsLoading] = useState<boolean>(false)

    useEffect(init, [])

    /**
     * Permite abrir a tela já filtrada (ex.: atalho do Dashboard) via ?f={matrixCode, locationCodes, dateRange}.
     */
    function init(): void {

        const queryFiltersStr = new URLSearchParams(routeLocation.search).get(SCREEN_FILTER_URL_PARAM)
        if (!queryFiltersStr)
            return

        const queryFilters: Partial<CollectionControlFiltersFormModel> = JSON.parse(queryFiltersStr)
        setFormModel(new CollectionControlFiltersFormModel({
            matrixCode: queryFilters.matrixCode,
            locationCodes: queryFilters.locationCodes,
            dateRange: queryFilters.dateRange,
        }))
        // Para garantir que o filtro ja foi atualizado antes de pesquisar
        SystemUtils.sleep(100).then(() => setReloadData(TableUtils.getReloadNumber()))
    }

    return (
        <LayoutCP
            header={<HeaderCP title={'Desempenho de Coleta — Controle de Pontos'}/>}
            overflowVertical={true}
            content={
                <>
                    <FiltersCollectionControlCP
                        formStateManager={formStateManager}
                        onFilter={() => setReloadData(TableUtils.getReloadNumber())}
                        isLoading={isLoading}
                    />

                    <TableCollectionControlCP
                        formStateManager={formStateManager}
                        reloadData={reloadData}
                        onLoading={setIsLoading}
                    />
                </>
            }
        />
    )
}
